import { MarkerIconType } from '@/models/marker-icon.model';

export function getMarkerModifier(mapIconId: string): string | null {
    const markerClassName = 'mdl-dealer-search-marker';
    
    switch (mapIconId) {
        case MarkerIconType.MyPlace:
        case MarkerIconType.MieleExperienceCenter:
            return `${markerClassName}--black`;
        default:
            return null;
    }
}

export function getMarkerMarkup(icon: string, text?: string, id?: string) {
    return `
        <div${id ? ` id="${id}"` : ''} class="mdl-dealer-search-marker__inner">
            <div class="mdl-dealer-search-marker__icon">
                <svg>
                    <use xlink:href="/wmedia/pwp/1.12.0/svg/applications-dealer-search.svg#${icon}"></use>
                </svg>
            </div>
            ${text ? `<div class="mdl-dealer-search-marker__text">${text}</div>` : ''}
        </div>`;

}